import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const MigaDesechoApi = () => {
    const [cargando, setCargando] = useState(false);

    const getPadresProductoTerminado = async (params) => {
        return api
            .get("padres_producto_terminado", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getSemanasPendientes = async (params) => {
        try {
            setCargando(true);
            const response = await api.get(
                "miga_desecho/semanas_pendientes",
                params,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getHistorialMigaDesecho = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("miga_desecho/historial", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const reportarMigaDesecho = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("miga_desecho/reportar", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const editarKgMigaDesecho = async (migaId, data) => {
        try {
            setCargando(true);
            const response = await api.post(
                `miga_desecho/${migaId}/editar_kg`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const cancelarMigaDesecho = async (migaId) => {
        try {
            setCargando(true);
            const response = await api.post(`miga_desecho/${migaId}/cancelar`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getPadresProductoTerminado,
        getSemanasPendientes,
        getHistorialMigaDesecho,
        reportarMigaDesecho,
        editarKgMigaDesecho,
        cancelarMigaDesecho,
        cargando,
    };
};
